import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { useContext, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { getNullLogger } from '@uniformdev/common';
import { getSubscriptionManager, initializeGlobalObject, appendArray, appendObject } from '@uniformdev/optimize-common-sitecore';
import { UniformContext } from '@uniformdev/optimize-react';
import { TrackerContext } from './TrackerContext';
import { useScripts } from './useScripts';
import { QUEUE_ENTRY_TYPE_TRACKER, getTrackerCookieSettings, getDispatchersForGa4Destinations } from '@uniformdev/tracking';
import { CONTEXT_SOURCE_SITECORE } from '@uniformdev/tracking';
import { UniformCookieNames, addSubscriptionsForTrackerCookies } from '@uniformdev/tracking';
import { getDispatchersForGaDestinations, getDispatchersForOracleDmpDestinations, getDispatchersForXdbDestinations } from '@uniformdev/tracking';
import { getDispatchersFromTrackingConfig } from '@uniformdev/tracking';
import { getDefaultDecaySettings } from '@uniformdev/tracking';
import { getSitecoreTracker, getMaxExpirationDate } from '@uniformdev/tracking';
import ReactGA3 from 'react-ga';
import ReactGA4 from 'react-ga4';
/**
 * Merge tracking scripts from tracking data and props, with
 * values from props having priority.
 * @param trackingConfig
 * @param props
 */
function getTrackerScripts(trackingConfig, props) {
  var _a;
  var scripts = {};
  appendObject((_a = trackingConfig === null || trackingConfig === void 0 ? void 0 : trackingConfig.settings) === null || _a === void 0 ? void 0 : _a.scripts, scripts);
  appendObject(props === null || props === void 0 ? void 0 : props.scripts, scripts);
  return scripts;
}
/**
 * When dispatchers are configured by a developer, they
 * are exposed in hook's props as destinations. This
 * function controls the process responsible for
 * converting these destinations into dispatchers.
 * @param props
 * @param logger
 */
function getDispatchersFromProps(props, args) {
  var dispatchers = [];
  if (props.ga) {
    appendArray(getDispatchersForGaDestinations([props.ga], args), dispatchers);
  }
  if (props.ga4) {
    appendArray(getDispatchersForGa4Destinations([props.ga4], args), dispatchers);
  }
  if (props.oracleDmp) {
    appendArray(getDispatchersForOracleDmpDestinations([props.oracleDmp], args), dispatchers);
  }
  if (props.xdb) {
    appendArray(getDispatchersForXdbDestinations([props.xdb], args), dispatchers);
  }
  return dispatchers;
}
/**
 * Get dispatchers from tracking data and props.
 * @param trackingConfig
 * @param props
 * @param logger
 */
function getDispatchers(trackingConfig, props, args) {
  //
  //
  var logger = args.logger;
  var fromProps = getDispatchersFromProps(props, args);
  if (fromProps.length > 0) {
    logger.debug("useSitecoreTracker - Dispatchers retrieved from destinations set on props.", {
      fromProps: fromProps
    });
  }
  //
  //
  var fromTrackingConfig = getDispatchersFromTrackingConfig(trackingConfig, args);
  if (fromTrackingConfig.length > 0) {
    logger.debug("useSitecoreTracker - Dispatchers retrieved from tracking config.", {
      fromTrackingConfig: fromTrackingConfig
    });
  }
  //
  //
  return fromProps.concat(fromTrackingConfig);
}
export function useSitecoreTracker(sitecoreContext, props) {
  var _a, _b;
  var trackerId = "SC_TRACKER";
  var logger = (_a = props === null || props === void 0 ? void 0 : props.logger) !== null && _a !== void 0 ? _a : getNullLogger();
  var renderModes = (_b = props === null || props === void 0 ? void 0 : props.renderModes) !== null && _b !== void 0 ? _b : ['normal'];
  var uniformContext = useContext(UniformContext);
  var trackerContext = useContext(TrackerContext);
  var _useCookies = useCookies([]),
    _useCookies2 = _slicedToArray(_useCookies, 3),
    cookies = _useCookies2[0],
    setCookie = _useCookies2[1],
    removeCookie = _useCookies2[2];
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    tracker = _useState2[0],
    setTracker = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    scriptsLoaded = _useState4[0],
    setScriptsLoaded = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    clientScripts = _useState6[0],
    setClientScripts = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    trackingConfig = _useState8[0],
    setTrackingConfig = _useState8[1];
  function getTrackingConfig() {
    var _a, _b;
    var tracking = sitecoreContext === null || sitecoreContext === void 0 ? void 0 : sitecoreContext.tracking;
    if (tracking) {
      logger.debug("useSitecoreTracker -   * Tracking config available directly off Sitecore context.", {
        sitecoreContext: sitecoreContext
      });
    } else {
      logger.debug("useSitecoreTracker -   * Tracking config is not available directly off Sitecore context. Try alternate location.", {
        sitecoreContext: sitecoreContext
      });
      tracking = (_b = (_a = sitecoreContext === null || sitecoreContext === void 0 ? void 0 : sitecoreContext.sitecore) === null || _a === void 0 ? void 0 : _a.context) === null || _b === void 0 ? void 0 : _b.tracking;
    }
    if (!tracking) {
      logger.debug("useSitecoreTracker -   * Unable to resolve tracking config from Sitecore context.", {
        sitecoreContext: sitecoreContext
      });
      return;
    }
    logger.debug("useSitecoreTracker -   * Finished resolving tracking config.", {
      trackingConfig: tracking,
      sitecoreContext: sitecoreContext
    });
    return tracking;
  }
  function getPersonalizationConfig() {
    var _a, _b;
    var personalization = sitecoreContext === null || sitecoreContext === void 0 ? void 0 : sitecoreContext.personalization;
    if (personalization) {
      logger.debug("useSitecoreTracker -   * Personalization config available directly off Sitecore context.", {
        sitecoreContext: sitecoreContext
      });
    } else {
      logger.debug("useSitecoreTracker -   * Personalization config is not available directly off Sitecore context. Try alternate location.", {
        sitecoreContext: sitecoreContext
      });
      personalization = (_b = (_a = sitecoreContext === null || sitecoreContext === void 0 ? void 0 : sitecoreContext.sitecore) === null || _a === void 0 ? void 0 : _a.context) === null || _b === void 0 ? void 0 : _b.personalization;
    }
    if (!personalization) {
      logger.debug("useSitecoreTracker -   * Unable to resolve personalization config from Sitecore context.", {
        sitecoreContext: sitecoreContext
      });
      return;
    }
    logger.debug("useSitecoreTracker -   * Finished resolving personalization config.", {
      personalizationConfig: personalization,
      sitecoreContext: sitecoreContext
    });
    return personalization;
  }
  function getPlaceholdersFromSitecoreContext(sitecoreContext) {
    var _a, _b, _c, _d, _e;
    if (sitecoreContext === null || sitecoreContext === void 0 ? void 0 : sitecoreContext.placeholders) {
      logger.debug("useSitecoreTracker -   * Placeholders available directly off Sitecore context.", {
        sitecoreContext: sitecoreContext
      });
      return sitecoreContext.placeholders;
    }
    if ((_a = sitecoreContext === null || sitecoreContext === void 0 ? void 0 : sitecoreContext.route) === null || _a === void 0 ? void 0 : _a.placeholders) {
      logger.debug("useSitecoreTracker -   * Placeholders available off Sitecore context route.", {
        sitecoreContext: sitecoreContext
      });
      return sitecoreContext.route.placeholders;
    }
    if ((_c = (_b = sitecoreContext === null || sitecoreContext === void 0 ? void 0 : sitecoreContext.sitecore) === null || _b === void 0 ? void 0 : _b.route) === null || _c === void 0 ? void 0 : _c.placeholders) {
      logger.debug("useSitecoreTracker -   * Placeholders available off Layout Service context.", {
        sitecoreContext: sitecoreContext
      });
      return (_e = (_d = sitecoreContext === null || sitecoreContext === void 0 ? void 0 : sitecoreContext.sitecore) === null || _d === void 0 ? void 0 : _d.route) === null || _e === void 0 ? void 0 : _e.placeholders;
    }
    logger.debug("useSitecoreTracker -   * Unable to resolve placeholders from Sitecore context.", {
      sitecoreContext: sitecoreContext
    });
  }
  function getPageStateFromSitecoreContext(sitecoreContext) {
    var _a, _b;
    if (sitecoreContext === null || sitecoreContext === void 0 ? void 0 : sitecoreContext.pageState) {
      logger.debug("useSitecoreTracker -   * Page state available directly off Sitecore context.", {
        sitecoreContext: sitecoreContext
      });
      return sitecoreContext.pageState;
    }
    if ((_b = (_a = sitecoreContext === null || sitecoreContext === void 0 ? void 0 : sitecoreContext.sitecore) === null || _a === void 0 ? void 0 : _a.context) === null || _b === void 0 ? void 0 : _b.pageState) {
      logger.debug("useSitecoreTracker -   * Page state available off Layout Service context.", {
        sitecoreContext: sitecoreContext
      });
      return sitecoreContext.sitecore.context.pageState;
    }
    logger.debug("useSitecoreTracker -   * Unable to resolve page state from Sitecore context.", {
      sitecoreContext: sitecoreContext
    });
  }
  function addOriginPersonalizationActivityToTrackingConfig(trackingConfig, sitecoreContext) {
    //
    //Origin-based personalization activity may be included on
    //renderings included in Sitecore context route data. The
    //personalization activity is only tracked if all dependencies
    //have been met. 
    //
    //Any dependencies for rendering in Sitecore context route
    //data are defined in tracking config personalization 
    //details.
    //
    //Activity and dependencies must be added to tracking config
    //personalization details. It is up to the context reader to
    //consider the dependencies and determine whether the activity
    //should get tracked.
    var placeholders = getPlaceholdersFromSitecoreContext(sitecoreContext);
    if (!placeholders) {
      logger.debug("useSitecoreTracker -   * No placeholders could be resolved from Sitecore context, so no personalization activity can be resolved.", {
        sitecoreContext: sitecoreContext
      });
      return;
    }
    //
    //Get activities from placeholders.
    var count = 0;
    var detailsWithActivities = {};
    Object.keys(placeholders).forEach(function (key) {
      var renderings = placeholders[key];
      if (Array.isArray(renderings)) {
        renderings.forEach(function (rendering) {
          if (rendering.uid && rendering.personalization) {
            detailsWithActivities[rendering.uid] = {
              activity: rendering.personalization
            };
            count++;
          }
        });
      }
    });
    if (count == 0) {
      logger.debug("useSitecoreTracker -   * No origin-based personalization activity was resolved from Sitecore context placeholders.", {
        trackingConfig: trackingConfig,
        sitecoreContext: sitecoreContext,
        placeholders: placeholders
      });
      return;
    }
    logger.debug("useSitecoreTracker -   START: Updating tracking config personalization details.", {
      trackingConfig: trackingConfig,
      sitecoreContext: sitecoreContext
    });
    //
    //
    if (!trackingConfig.personalization) {
      trackingConfig.personalization = {};
    }
    var tDetails = trackingConfig.personalization;
    //
    //Assign activities to tracking config.
    Object.keys(detailsWithActivities).forEach(function (key) {
      var _a;
      var sActivity = (_a = detailsWithActivities[key]) === null || _a === void 0 ? void 0 : _a.activity;
      if (!sActivity) return;
      if (!tDetails[key]) {
        tDetails[key] = {};
      }
      var tActivity = tDetails[key].activity;
      if (tActivity) {
        logger.warn("useSitecoreTracker -     * Tracking config already has activity assigned for rendering. This will not be overwritten with new activity from Sitecore context.", {
          rendering: key,
          current: tActivity,
          new: sActivity
        });
        return;
      }
      tDetails[key].activity = sActivity;
      logger.debug("useSitecoreTracker -     * Origin-based personalization activity for rendering was added to tracking config personalization details.", {
        rendering: key,
        activity: sActivity
      });
    });
    //
    //Get dependencies from context.
    var detailsWithDependencies = getPersonalizationConfig();
    if (!detailsWithDependencies) {
      logger.debug("useSitecoreTracker -     * No personalization details are set on Sitecore context, so no dependencies will be added to tracking config personalization details.", {
        trackingConfig: trackingConfig,
        sitecoreContext: sitecoreContext
      });
    } else {
      logger.debug("useSitecoreTracker -     START: Resolve dependencies from Sitecore context personalization details.", {
        trackingConfig: trackingConfig,
        sitecoreContext: sitecoreContext
      });
      var _count = 0;
      Object.keys(detailsWithDependencies).forEach(function (key) {
        var _a;
        var sDependencies = (_a = detailsWithDependencies[key]) === null || _a === void 0 ? void 0 : _a.dependencies;
        if (!sDependencies) return;
        if (!tDetails[key]) {
          tDetails[key] = {};
        }
        var tDependencies = tDetails[key].dependencies;
        if (tDependencies) {
          logger.warn("useSitecoreTracker -       * Tracking config already has dependencies assigned for rendering. This will not be overwritten with new dependencies from Sitecore context.", {
            rendering: key,
            current: tDependencies,
            new: sDependencies
          });
          return;
        }
        tDetails[key].dependencies = sDependencies;
        _count++;
        logger.debug("useSitecoreTracker -       * Personalization dependencies for rendering were added to tracking config personalization details.", {
          rendering: key,
          dependencies: sDependencies
        });
      });
      logger.debug("useSitecoreTracker -     END: Resolve dependencies from Sitecore context personalization details.", {
        count: _count,
        trackingConfig: trackingConfig,
        sitecoreContext: sitecoreContext
      });
    }
    logger.debug("useSitecoreTracker -   END: Updating tracking config personalization details.", {
      trackingConfig: trackingConfig,
      sitecoreContext: sitecoreContext
    });
  }
  function updateCookieVisitorId(visitorId, results) {
    var _a, _b;
    var newId = (_b = (_a = results.visitor) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : visitorId;
    if (visitorId != newId) {
      logger.debug('useSitecoreTracker - Updating the visitor id cookie.', {
        old: visitorId,
        new: newId
      });
      var date = getMaxExpirationDate();
      setCookie(UniformCookieNames.VisitorId, newId, {
        path: "/",
        expires: date
      });
    }
    return newId;
  }
  function updateCookieVisitId(visitId, results) {
    var _a, _b;
    var newId = (_b = (_a = results.visit) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : visitId;
    if (visitId != newId) {
      logger.debug('useSitecoreTracker - Updating the visit id cookie.', {
        old: visitId,
        new: newId
      });
      setCookie(UniformCookieNames.VisitId, newId, {
        path: "/"
      });
    }
    return newId;
  }
  function updateCookieVisitState(sessionTimeout, results) {
    if (!results.visit) {
      return;
    }
    var parts = [new Date(results.visit.start).getTime(), new Date(results.visit.updated).getTime(), sessionTimeout];
    var oldValue = cookies[UniformCookieNames.VisitState];
    var newValue = parts.join("|");
    setCookie(UniformCookieNames.VisitState, newValue);
    logger.debug("useSitecoreTracker - Updating the visit state cookie.", {
      old: oldValue,
      new: newValue,
      cookie: UniformCookieNames.VisitState
    });
    return newValue;
  }
  function onScriptsLoaded() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee3() {
      var _this = this;
      var trackerSubs, cookieSettings, unsubscribes, contextSubs, unsubscribe, dispatchers, contextReaders, sessionTimeout, campaignParameters, goalParameters, args, scTracker, visitorId, visitId, trackingSettings, results, _results, queue, handleEntry, entry, _unsubscribe;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            //
            //Add subscriptions to tracker.
            trackerSubs = getSubscriptionManager("".concat(trackerId, "_SUBS"));
            if (props === null || props === void 0 ? void 0 : props.subscriptions) {
              logger.debug("useSitecoreTracker -   * Adding subscriptions from props to the tracker.");
              props.subscriptions(trackerSubs.subscribe);
            } else {
              logger.debug("useSitecoreTracker -   * No subscriptions are set on props, so no subscribers will be added to the tracker.");
            }
            //
            //Use cookie settings from props if available, otherwise use from tracking config.
            cookieSettings = (props === null || props === void 0 ? void 0 : props.cookies) ? props.cookies : getTrackerCookieSettings(trackingConfig); //
            //
            logger.debug("useSitecoreTracker -   * Adding subscriptions for tracker cookies.", {
              manager: trackerSubs.id
            });
            addSubscriptionsForTrackerCookies(trackerSubs, {
              cookieSettings: cookieSettings,
              getCookieName: props === null || props === void 0 ? void 0 : props.getCookieName,
              getCookieValueFromVisit: props === null || props === void 0 ? void 0 : props.getCookieValueFromVisit,
              getCookieValueFromVisitor: props === null || props === void 0 ? void 0 : props.getCookieValueFromVisitor,
              logger: logger,
              loggerPrefix: "useSitecoreTracker",
              getCookie: function getCookie(name) {
                return cookies[name];
              },
              removeCookie: removeCookie,
              setCookie: setCookie
            });
            //
            //Add subscription to publish tracker events to the context.
            unsubscribes = [];
            if (!uniformContext.subscriptions) {
              uniformContext.subscriptions = getSubscriptionManager("UNIFORM_CONTEXT_SUBS", false, logger);
              logger.warn("useSitecoreTracker -   * No subscription manager was assigned to the Uniform context. One was just assigned, but this should not happen.", {
                id: uniformContext.subscriptions.id,
                uniformContext: uniformContext
              });
            }
            contextSubs = uniformContext.subscriptions;
            if (contextSubs) {
              logger.debug("useSitecoreTracker -   * Adding subscription for all tracker events to be republished to the Uniform context subscription manager.", {
                trackerManager: trackerSubs.id,
                contextManager: contextSubs.id
              });
              unsubscribe = trackerSubs.subscribe(undefined, function (e) {
                logger.debug("useSitecoreTracker -   * Event the tracker was subscribed to was fired. Publish the event to the Uniform context subscription manager.", {
                  event: e,
                  trackerManager: trackerSubs.id,
                  contextManager: contextSubs.id
                });
                contextSubs.publish(e);
              });
              if (unsubscribe) {
                unsubscribes.push(unsubscribe);
              }
            }
            //
            //React-specific code is needed to initialize the GA dispatcher.
            //This code is passed to the dispatcher.
            logger.debug("useSitecoreTracker -   * Resolving dispatchers.", {
              trackingConfig: trackingConfig
            });
            dispatchers = getDispatchers(trackingConfig, props !== null && props !== void 0 ? props : {}, {
              logger: logger,
              loggerPrefix: "useSitecoreTracker",
              getCookie: function getCookie(name) {
                return cookies[name];
              },
              setCookie: setCookie,
              removeCookie: removeCookie,
              ga: {
                initializeGa: function initializeGa(destination, logger) {
                  if (!destination.trackingIds || destination.trackingIds.length == 0) {
                    logger.debug("useSitecoreTracker - GA UA destination has no tracking ids assigned, so no GA initialization will be performed.", {
                      destination: destination
                    });
                    return false;
                  }
                  var didInitialize = true;
                  destination.trackingIds.forEach(function (id) {
                    logger.debug("useSitecoreTracker - Will initialize GA UA from tracking id.", {
                      id: id
                    });
                    try {
                      ReactGA3.initialize(id, {
                        gaOptions: {
                          name: id
                        }
                      });
                    } catch (ex) {
                      logger.error("useSitecoreTracker - Error while initializing GA UA from tracking id.", {
                        id: id,
                        ex: ex
                      });
                      didInitialize = false;
                    }
                  });
                  return didInitialize;
                }
              },
              ga4: {
                initializeGa4: function initializeGa4(destination, logger) {
                  if (!destination.measurementIds || destination.measurementIds.length == 0) {
                    logger.debug("useSitecoreTracker - GA4 destination has no measurement ids assigned, so no GA4 initialization will be performed.", {
                      destination: destination
                    });
                    return false;
                  }
                  var didInitialize = true;
                  destination.measurementIds.forEach(function (id) {
                    logger.debug("useSitecoreTracker - Will initialize GA4 from measurement id.", {
                      id: id
                    });
                    try {
                      ReactGA4.initialize(id, {
                        gaOptions: {
                          name: id
                        }
                      });
                    } catch (ex) {
                      logger.error("useSitecoreTracker - Error while initializing GA4 from measurement id.", {
                        id: id,
                        ex: ex
                      });
                      didInitialize = false;
                    }
                  });
                  return didInitialize;
                }
              }
            });
            if (dispatchers.length == 0) {
              logger.debug("useSitecoreTracker -   * No dispatchers were resolved.");
            } else {
              logger.debug("useSitecoreTracker -   * Dispatchers were resolved.", {
                dispatchers: dispatchers
              });
            }
            //
            //
            contextReaders = new Map();
            if (props === null || props === void 0 ? void 0 : props.contextReaders) {
              logger.debug("useSitecoreTracker -   * Adding context readers from props.", {
                key: CONTEXT_SOURCE_SITECORE,
                readers: props.contextReaders
              });
              contextReaders.set(CONTEXT_SOURCE_SITECORE, props.contextReaders);
            }
            //
            //
            sessionTimeout = 20;
            if (props === null || props === void 0 ? void 0 : props.sessionTimeout) {
              logger.debug("useSitecoreTracker -   * Use session timeout value from props.", {
                props: props
              });
              sessionTimeout = props.sessionTimeout;
            } else if ((_b = (_a = trackingConfig.settings) === null || _a === void 0 ? void 0 : _a.session) === null || _b === void 0 ? void 0 : _b.timeout) {
              logger.debug("useSitecoreTracker -   * Use session timeout value from tracking config.", {
                trackingConfig: trackingConfig
              });
              sessionTimeout = trackingConfig.settings.session.timeout;
            } else {
              logger.debug("useSitecoreTracker -   * Use default session timeout value.", {
                sessionTimeout: sessionTimeout
              });
            }
            //
            //

            if (Array.isArray(props === null || props === void 0 ? void 0 : props.campaignParameters)) {
              logger.debug("useSitecoreTracker -   * Use campaign parameters from props.", {
                props: props
              });
              campaignParameters = props === null || props === void 0 ? void 0 : props.campaignParameters;
            } else if (Array.isArray((_d = (_c = trackingConfig.settings) === null || _c === void 0 ? void 0 : _c.campaigns) === null || _d === void 0 ? void 0 : _d.parameters)) {
              logger.debug("useSitecoreTracker -   * Use campaign parameters from tracking config.", {
                trackingConfig: trackingConfig
              });
              campaignParameters = (_f = (_e = trackingConfig.settings) === null || _e === void 0 ? void 0 : _e.campaigns) === null || _f === void 0 ? void 0 : _f.parameters;
            } else {
              logger.debug("useSitecoreTracker -   * No campaign parameters will be used.", {
                props: props,
                trackingConfig: trackingConfig
              });
            }
            //
            //

            if (Array.isArray(props === null || props === void 0 ? void 0 : props.goalParameters)) {
              logger.debug("useSitecoreTracker -   * Use goal parameters from props.", {
                props: props
              });
              goalParameters = props === null || props === void 0 ? void 0 : props.goalParameters;
            } else if (Array.isArray((_h = (_g = trackingConfig.settings) === null || _g === void 0 ? void 0 : _g.goals) === null || _h === void 0 ? void 0 : _h.parameters)) {
              logger.debug("useSitecoreTracker -   * Use goal parameters from tracking config.", {
                trackingConfig: trackingConfig
              });
              goalParameters = (_k = (_j = trackingConfig.settings) === null || _j === void 0 ? void 0 : _j.goals) === null || _k === void 0 ? void 0 : _k.parameters;
            } else {
              logger.debug("useSitecoreTracker -   * No goal parameters will be used.", {
                props: props,
                trackingConfig: trackingConfig
              });
            }
            //
            //
            args = {
              campaignParameters: campaignParameters,
              contextReaders: contextReaders,
              decay: (_l = props === null || props === void 0 ? void 0 : props.decay) !== null && _l !== void 0 ? _l : getDefaultDecaySettings(),
              dispatchers: dispatchers,
              onDispatch: props === null || props === void 0 ? void 0 : props.onDispatch,
              goalParameters: goalParameters,
              logger: logger,
              sessionTimeout: sessionTimeout,
              type: (_m = props === null || props === void 0 ? void 0 : props.type) !== null && _m !== void 0 ? _m : 'default',
              storage: (_o = props === null || props === void 0 ? void 0 : props.storage) !== null && _o !== void 0 ? _o : 'default',
              subscriptions: trackerSubs
            }; //
            //Get the tracker
            logger.debug('useSitecoreTracker -   * Resolving the tracker.', {
              settings: args
            });
            scTracker = getSitecoreTracker(args, logger);
            if (scTracker) {
              _context3.n = 1;
              break;
            }
            logger.error('useSitecoreTracker -   * No tracker was resolved.');
            return _context3.a(2);
          case 1:
            setTracker(scTracker);
            logger.debug('useSitecoreTracker -   * Tracker was resolved.', {
              tracker: scTracker
            });
            //
            //Update the tracker context.
            logger.debug('useSitecoreTracker -   * Updating the tracker context.', {
              tracker: tracker === null || tracker === void 0 ? void 0 : tracker.id,
              trackerContext: trackerContext
            });
            trackerContext.tracker = scTracker;
            if (trackerContext.subscriptions) {
              logger.debug('useSitecoreTracker -   * Publishing event to subscribers on the tracker context to indicate that the tracker is ready.', {
                tracker: tracker === null || tracker === void 0 ? void 0 : tracker.id,
                manager: trackerContext.subscriptions.id,
                trackerContext: trackerContext
              });
              trackerContext.subscriptions.publish({
                type: "tracker-set",
                when: new Date(),
                tracker: scTracker
              });
            }
            //
            //
            unsubscribes.push(scTracker.subscribe("tracking-finished", function (e) {
              if (props && !props.clientSideRouting) {
                logger.debug("useSitecoreTracker - Tracking finished and not in client-side routing mode, so set flag on tracker context to indicate refresh is needed.", {
                  event: e
                });
                trackerContext.needsRefresh = true;
              }
            }));
            //
            //Get visitor id for tracker settings.
            logger.debug('useSitecoreTracker -   * Current cookies.', {
              cookies: cookies
            });
            visitorId = cookies[UniformCookieNames.VisitorId];
            if (visitorId) {
              logger.debug('useSitecoreTracker -   * Found visitor id in cookie.', {
                cookie: UniformCookieNames.VisitorId,
                value: visitorId
              });
            } else {
              logger.debug('useSitecoreTracker -   * Visitor id not found in cookie, so check tracker context.');
              visitorId = trackerContext.visitorId;
              if (visitorId) {
                logger.debug('useSitecoreTracker -   * Found visitor id in tracker context.', {
                  value: visitorId
                });
              }
            }
            if (!visitorId) {
              logger.debug('useSitecoreTracker -   * No visitor id was found.');
            }
            //
            //Get visit id for tracker settings.
            visitId = cookies[UniformCookieNames.VisitId];
            if (visitId) {
              logger.debug('useSitecoreTracker -   * Found visit id in cookie.', {
                cookie: UniformCookieNames.VisitId,
                value: visitId
              });
            } else {
              logger.debug('useSitecoreTracker -   * No visit id was found.');
            }
            //
            //
            trackingSettings = {
              visitId: visitId,
              visitorId: visitorId,
              createVisitor: true,
              onVisitorInitialized: props === null || props === void 0 ? void 0 : props.onVisitorInitialized,
              lastActivity: (_r = (_q = (_p = window.uniform) === null || _p === void 0 ? void 0 : _p.tracking) === null || _q === void 0 ? void 0 : _q.visit) === null || _r === void 0 ? void 0 : _r.lastActivity,
              isNew: (_u = (_t = (_s = window.uniform) === null || _s === void 0 ? void 0 : _s.tracking) === null || _t === void 0 ? void 0 : _t.visit) === null || _u === void 0 ? void 0 : _u.isNew
            }; //
            //Use the tracker.
            if (!((props === null || props === void 0 ? void 0 : props.clientSideRouting) == true)) {
              _context3.n = 3;
              break;
            }
            logger.debug('useSitecoreTracker -   * Client-side routing is enabled, so only initialize the tracker. ' + 'The tracker must be called in the application, after the application determines the route has changed.');
            _context3.n = 2;
            return scTracker.initialize(trackingSettings);
          case 2:
            results = _context3.v;
            logger.debug('useSitecoreTracker -   * Received tracking results from tracker initialization.', results);
            visitorId = updateCookieVisitorId(visitorId, results);
            visitId = updateCookieVisitId(visitId, results);
            updateCookieVisitState(sessionTimeout, results);
            _context3.n = 5;
            break;
          case 3:
            logger.debug('useSitecoreTracker -   * Client-side routing is disabled, so track using tracking data.', {
              props: props,
              trackingConfig: trackingConfig,
              trackingSettings: trackingSettings
            });
            _context3.n = 4;
            return scTracker.track('sitecore', trackingConfig, trackingSettings);
          case 4:
            _results = _context3.v;
            logger.debug('useSitecoreTracker -   * Received tracking results from tracking with tracking data.', {
              visitorId: visitorId,
              results: _results
            });
            visitorId = updateCookieVisitorId(visitorId, _results);
            visitId = updateCookieVisitId(visitId, _results);
            updateCookieVisitState(sessionTimeout, _results);
          case 5:
            if (trackerContext.visitorId != visitorId) {
              logger.debug('useSitecoreTracker -   * Update visitor id on tracker context.', {
                current: trackerContext.visitorId,
                new: visitorId
              });
              trackerContext.visitorId = visitorId;
            }
            //
            //
            if (props === null || props === void 0 ? void 0 : props.onInitialized) {
              logger.debug('useSitecoreTracker -   * Event handler for tracker initialization was set on props, so call it.', {
                props: props
              });
              props.onInitialized();
            }
            //
            //Components can use the global queue to capture
            //tracker events even if the tracker is not yet
            //initialized. Now that the tracker is being 
            //initialized, it is time to handle those events.
            queue = (_v = window.uniform) === null || _v === void 0 ? void 0 : _v.queue;
            if (queue) {
              _context3.n = 6;
              break;
            }
            logger.debug('useSitecoreTracker -   * No global queue is defined, so there are no tracker events to process.', {
              visitorId: visitorId
            });
            _context3.n = 12;
            break;
          case 6:
            handleEntry = function handleEntry(entry) {
              return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
                var _w, _tracker, settings, _results2;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      if (!entry) {
                        _context.n = 2;
                        break;
                      }
                      _tracker = (_w = window.uniform) === null || _w === void 0 ? void 0 : _w.tracker;
                      if (!_tracker) {
                        _context.n = 2;
                        break;
                      }
                      settings = {
                        visitorId: visitorId
                      };
                      logger.debug('useSitecoreTracker - Track using global queue entry data.', {
                        queue: queue.id,
                        entry: entry,
                        settings: settings
                      });
                      _context.n = 1;
                      return _tracker.event(entry.type, entry.e, settings);
                    case 1:
                      _results2 = _context.v;
                      logger.debug('useSitecoreTracker - Received tracking results from tracking with global queue entry data.', _results2);
                      visitorId = updateCookieVisitorId(visitorId, _results2);
                    case 2:
                      return _context.a(2);
                  }
                }, _callee);
              }));
            }; //
            //Process entries already in the global queue.
            if (!(queue.count(QUEUE_ENTRY_TYPE_TRACKER) === 0)) {
              _context3.n = 7;
              break;
            }
            logger.debug('useSitecoreTracker -   * No tracker entries in the global queue to process.', {
              queue: queue.id,
              visitorId: visitorId
            });
            _context3.n = 11;
            break;
          case 7:
            logger.debug('useSitecoreTracker -   START: handle existing tracker entries from the global queue.', {
              queue: queue.id,
              visitorId: visitorId
            });
          case 8:
            if (!(queue.count(QUEUE_ENTRY_TYPE_TRACKER) > 0)) {
              _context3.n = 10;
              break;
            }
            entry = queue.get(QUEUE_ENTRY_TYPE_TRACKER);
            logger.debug('useSitecoreTracker -     * Handle existing tracker entry.', {
              queue: queue.id,
              entry: entry,
              visitorId: visitorId
            });
            _context3.n = 9;
            return handleEntry(entry);
          case 9:
            _context3.n = 8;
            break;
          case 10:
            logger.debug('useSitecoreTracker -   END: handle existing tracker entries from the global queue.', {
              queue: queue.id,
              visitorId: visitorId
            });
          case 11:
            //
            //Subscribe to the global queue.
            logger.debug('useSitecoreTracker -   * Add subscriptions for subsequent tracker entries to the global queue.', {
              queue: queue.id,
              visitorId: visitorId
            });
            _unsubscribe = queue.subscribe(QUEUE_ENTRY_TYPE_TRACKER, function (e) {
              return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee2() {
                var entry;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      logger.debug('useSitecoreTracker - Handle tracker entry.', {
                        queue: queue.id,
                        entry: e.entry,
                        visitorId: visitorId
                      });
                      entry = e.entry;
                      _context2.n = 1;
                      return handleEntry(entry);
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              }));
            });
            if (_unsubscribe) {
              unsubscribes.push(_unsubscribe);
            }
          case 12:
            return _context3.a(2, function cleanup() {
              logger.debug("useSitecoreTracker - CLEANUP EFFECT: Scripts loaded flag changed.");
              unsubscribes.forEach(function (unsub) {
                logger.debug('useSitecoreTracker -   * Removing subscription for tracker entries from global queue.', {
                  subscription: unsub.id,
                  queue: queue === null || queue === void 0 ? void 0 : queue.id
                });
                unsub.unsub();
              });
            });
        }
      }, _callee3);
    }));
  }
  function isSupportedRenderMode() {
    var pageState = getPageStateFromSitecoreContext(sitecoreContext);
    if (pageState) return renderModes.includes(pageState);
    return false;
  }
  /**
   * Sitecore context object changed.
   */
  useEffect(function () {
    if (!sitecoreContext) return;
    if (!isSupportedRenderMode()) return;
    logger.debug("useSitecoreTracker - START EFFECT: Sitecore context changed.", {
      sitecoreContext: sitecoreContext
    });
    //
    //
    var config = getTrackingConfig();
    setTrackingConfig(config);
    //
    //This hook usually is passed the Sitecore context, and this context
    //may change as the page is loaded. As a result, this hook shouldn't
    //run until it's clear that enough context data is available to run.
    if (!config) {
      logger.debug("useSitecoreTracker -   * No tracking config object was resolved. The tracker cannot be loaded until this object is available.", {
        sitecoreContext: sitecoreContext
      });
    } else {
      //
      //
      addOriginPersonalizationActivityToTrackingConfig(config, sitecoreContext);
      //
      //
      var scripts = getTrackerScripts(config, props);
      setClientScripts(scripts);
      logger.debug("useSitecoreTracker -   * Set tracker context logger.", {
        logger: logger
      });
      trackerContext.logger = logger;
    }
    logger.debug("useSitecoreTracker - END EFFECT: Sitecore context changed.");
  }, [sitecoreContext]);
  /**
   * Load scripts.
   */
  useScripts(clientScripts, function (_scripts) {
    if (scriptsLoaded == true) return;
    logger.debug("useSitecoreTracker - START: useScripts callback.", {
      clientScripts: clientScripts
    });
    initializeGlobalObject(logger);
    logger.info("useSitecoreTracker - Scripts are loaded.", clientScripts);
    setScriptsLoaded(true);
    logger.debug("useSitecoreTracker - END: useScripts callback.", {
      clientScripts: clientScripts
    });
  });
  /**
   * Scripts loaded.
   */
  useEffect(function () {
    if (!isSupportedRenderMode()) return;
    if (!trackingConfig) return;
    if (scriptsLoaded !== true) return;
    logger.info("useSitecoreTracker - START EFFECT: Scripts loaded flag changed.", {
      flag: scriptsLoaded,
      clientScripts: clientScripts
    });
    //
    //Logic is in function in order to call async code in hook.
    onScriptsLoaded().then(function () {
      logger.info("useSitecoreTracker - END EFFECT: Scripts loaded flag changed.");
    });
  }, [scriptsLoaded, trackingConfig]);
  return tracker;
}